<script>
import formatDateMixin from '@/mixins/formatDateMixin'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CandidateQualifications',
  mixins: [formatDateMixin],
  props: {
    qualifications: {
      type: Array,
      default: null,
    },
    timeZone: {
      type: String,
      default: null,
    },
  },
  data: () => {
    return {
      loaderIndex: -1,
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'file/isLoading',
    }),
  },
  methods: {
    ...mapActions({
      download: 'file/download',
    }),

    async downloadFile(fileId, i) {
      this.loaderIndex = i
      await this.download(fileId)
    },
  },
}
</script>

<template>
  <v-card flat>
    <v-simple-table class="pa-10">
      <template v-slot>
        <thead>
          <tr>
            <th class="text-left">Institute</th>
            <th class="text-left">Degree</th>
            <th class="text-left">Date Completed</th>
            <th class="text-left">Teaching Methods</th>
            <th class="text-left">Downloads</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(qual, i) in qualifications"
            :key="`candidateQualifications_quals_${qual.id + i}`"
          >
            <td>{{ qual.institute }}</td>
            <td>{{ qual.degree }}</td>
            <td class="font-monospace">
              {{ renderDate(qual.completedUTC, timeZone) }}
            </td>
            <td>
              <v-chip-group v-if="qual.grades && qual.grades.length > 0">
                <v-chip
                  v-for="(grade, gi) in qual.grades"
                  :key="`candidateQualifications_grades_${grade.id + gi}`"
                  class="ma-1"
                  small
                >
                  {{ grade.title }}
                </v-chip>
              </v-chip-group>
            </td>
            <td class="text-center">
              <v-col
                v-for="(file, fi) in qual.files"
                :key="`qualificationFiles_files_${file.fileId + fi}`"
                cols="1"
                class="pa-1"
              >
                <v-btn
                  x-small
                  text
                  color="primary"
                  :loading="isLoading && file.fileId + fi === loaderIndex"
                  @click="downloadFile(file.fileId, file.fileId + fi)"
                >
                  <v-icon left dark>
                    mdi-cloud-download
                  </v-icon>
                  <span class="hidden-sm-and-down">File {{ i + 1 }}</span>
                </v-btn>
              </v-col>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>

<style lang="scss" module>
@import '@styles';
</style>
